import {TextArea} from '@sanity/ui'
import styled from 'styled-components'

export const CodeTextArea = styled(TextArea)`
  font-family: ${({theme}) => theme.sanity.fonts.code.family};
  overflow-wrap: normal;
`
